import { Component, OnInit } from '@angular/core';
import {Apikeys} from '../../../../_models/apikeys';
import {NavigationExtras, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {PageHeaderDataService} from '../../../../shared/services/page-header-data.service';
import {ApikeysService} from '../apikeys.service';
import {PageHeaderData} from '../../../../shared/components/forms-header/page-header-data';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {FormBuilder} from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';

@Component({
  selector: 'app-list-apikeys',
  templateUrl: './list-apikeys.component.html',
  styleUrls: ['./list-apikeys.component.scss']
})
export class ListApikeysComponent implements OnInit {
  // tableColumns = [{name: 'Nombre Fantasía', val: 'nombreFantasia'}, {name: 'Web', val: 'web'}, {name: 'Ruc', val: 'ruc'}, {name: 'Correo', val: 'email'}];
  displayedColumns = ['nombreFantasia', 'ruc', 'web', 'email', 'acciones' ];
  elementos = [];
  dataSource: Array<Apikeys> = [];
  filter: any = {
    nombreFantasia: '',
    web: '',
    ruc: '',
    email: '',
    cantidadPagina: 10,
    pagina: 1
  };
  panelOpenState = true; // muestra/oculta el filtro
  paginacion: any = {
    cantidad: 0,
    por_pagina: 10,
    pagina: 1,
    total: 0,
  };
  filterTimer: any;
  formFilter = null;
  unsubscribe$: Subject<any> = new Subject();

  constructor(
    public router: Router,
    public service: ApikeysService,
    public dialog: MatDialog,
    private headerDataService: PageHeaderDataService,
    private fb: FormBuilder,
  ) {
    this.buildForm();
  }

  ngOnInit(): void {
    this.headerDataService.setHeaderData(new PageHeaderData('Api Keys', 'procesadora/apikeys', false, false));
    this.obtenerListaApikey();
  }

  private buildForm() {
    this.formFilter = this.fb.group({
      nombreFantasia: [''],
      web: [''],
      ruc: [''],
      email: [''],
    });

    // se enlazan filtros con formulario reactivo
    this.formFilter.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe( data => {
      clearTimeout(this.filterTimer);
      this.filterTimer = setTimeout(() => {
        this.filter.nombreFantasia = data.nombreFantasia;
        this.filter.web = data.web;
        this.filter.ruc = data.ruc;
        this.filter.email = data.email;
        this.obtenerListaApikey();
        clearTimeout(this.filterTimer);
      }, 500);
    });
  }

  mostrarDetalle(item: Apikeys): void {
    const extra: NavigationExtras = {
      state: item
    };

    this.router.navigate(['procesadora/apikeys/ver'], extra);
  }

  /**
   * Método para realizar acción según evento del paginado.
   * @param event evento del paginado
   */
  public obtenerDatos(event?: PageEvent) {
    let pagina = 1;
    pagina = event.pageIndex + 1;
    if (event.pageIndex === 0 && event.previousPageIndex === 1) {
      pagina = 1;
    }
    this.filter.cantidadPagina = event.pageSize;
    this.filter.pagina = pagina;
    this.obtenerListaApikey();
    return event;
  }

  private obtenerListaApikey() {
    this.service.getAll(this.filter)
      .subscribe(
        data => {
          if (data != null) {
            this.dataSource = data.data as any[];
            //this.paginacion = data.pagination;
            if (data.pagination) {
              this.paginacion.actual = +data.pagination.actual;
              this.paginacion.cantidad = +data.pagination.cantidad;
              this.paginacion.por_pagina = +data.pagination.por_pagina;
              this.paginacion.total = +data.pagination.total;
            }
          } else {
            this.dataSource = [];
            //this.paginacion = {};
            this.paginacion = {
              actual: 1,
              cantidad: 1,
              por_pagina: 10,
              total: 1
            };
          }
          // this.snackbar.noMessage();
        });
  }
}
